const state = {
  shop: undefined,
  loaded: false
}

const mutations = {
  SET_SHOP(state, shop) {
    state.shop = shop
    state.loaded = true
  }
}

const actions = {
  loadShop({ commit }, shop) {
    commit('SET_SHOP', shop)
  },
}

const getters = {
  shop: state => state.shop,
  isLoaded: state => state.loaded
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}